(() => {
    const discovery = {
        init() {
            window.discovery_config.forEach((o) => {
                let cards = [];
                let searchJSON = o.search_url;
                const target = document.querySelector(o.trigger);

                /** Infinity (optional fetch method) */
                if (o.fetch_method === "infinity") {
                    // Observer callback
                    const callback = (entries, observer) => { 
                        entries.forEach((entry) => {
                            if (entry.isIntersecting === true) {
                                fetchAssets();
                            }
                        });
                    };
                    
                    // Initialize observer
                    const config = { rootMargin: "0px 0px 0px" };
                    const observer = new IntersectionObserver(callback, config);
                    observer.observe(target);
                }
                
                /** Load more (optional fetch method) */
                else if (o.fetch_method === "more") {
                    target.addEventListener("click", (e) => {
                        target.loading = true;
                        target.disabled = true;
                        fetchAssets(() => {
                            target.loading = false;
                            target.disabled = false;
                        });
                    });
                }
                
                // Fetch assets
                const fetchAssets = async (callback) => {
                    try {
                        const response = await fetch(searchJSON);
                        if (response.status !== 200) {
                            console.error(`Error: ${response.status}`);
                            hideTrigger();
                            return;
                        }
                        const data = await response.json();
                        
                        // Prepare for next run
                        if (data.next !== 0) {
                            searchJSON = searchJSON.includes('&o=') 
                                ? searchJSON.replace(/&o=[0-9]*/g, `&o=${data.next}`)
                                : `${searchJSON}&o=${data.next}`;
                        } else {
                            // End of results
                            hideTrigger();
                        }
                        
                        // Populate assets
                        populateCards(data.assets);
                        
                        // Callback
                        callback?.();
                    } catch (err) {
                        console.error("Fetch Error: ", err);
                        hideTrigger();
                    }
                };
                
                // Populate cards with fetched assets
                const populateCards = (assets) => {
                    if (assets) {
                        fillTemplate(assets);   // Inserts asset data into card templates
                        renderCards();          // Drops card on to the page
                        pageManagement();       // Handles offpage display
                    } else {
                        console.error("Content discovery error: Unexpected JSON response.");
                        hideTrigger();
                    }
                };
                
                // Insert cards
                const renderCards = () => {
                    const df = document.createDocumentFragment();
                    const page = document.createElement("div");
                    const content = document.createElement("div");
                    
                    page.classList.add("page");
                    content.classList.add("content");
                    
                    df.appendChild(page);
                    df.querySelector(".page").appendChild(content);
                    
                    cards.forEach((card) => {
                        df.querySelector(".content").appendChild(card);
                    });
                    
                    if (o.fetch_method === "select") {
                        // Clear dropzone for new assets
                        document.querySelector(o.drop_zone).innerHTML = "";
                        
                        // Show/hide dropzone
                        document.querySelector(o.drop_zone).classList.remove("hidden");
                    }
                    
                    document.querySelector(o.drop_zone).appendChild(df);
                };
                
                // Manage offscreen pages and return to previous pages
                const pageManagement = () => {
                    if (o.fetch_method === "select") return;
                    
                    const returnCallback = (entries, returnObserver) => {
                        entries.forEach((entry) => {
                            entry.target.firstElementChild.toggleAttribute("hidden", !entry.isIntersecting);
                        });
                    };
                    
                    const container = document.querySelector(o.drop_zone);
                    const arrival = container.lastElementChild;
                    const active = arrival?.previousElementSibling;
                    
                    if (active) {
                        const prev = active.previousElementSibling;
                        if (prev) {
                            const height = prev.offsetHeight;
                            prev.style.height = `${height}px`;
                            prev.firstElementChild.setAttribute("hidden", true);
                            prev.classList.add("return-trigger");
                            // Observe removed page for later interaction
                            const config = {
                                rootMargin: "100px 0px 100px"
                            };
                            const returnObserver = new IntersectionObserver(returnCallback, config);
                            returnObserver.observe(prev);
                        }
                    }
                };
                
                // Fill template
                const fillTemplate = (assets) => {
                    if (assets.length <= 0) return;

                    assets.forEach((asset) => {
                        if (!asset.published) return;
                        
                        const template = document.querySelector(o.template);
                        const clone = template.content.cloneNode(true);
                        const card = clone.querySelector("blox-card");
                        const headline = clone.querySelector('[slot="headline"]');
                        
                        // Title
                        headline.textContent = asset.title;
                        headline.href = asset.url;
                        
                        // Open links in a new window
                        if (asset.new_window) {
                            headline.target = '_blank';
                            headline.rel = 'noopener';
                        }
                        
                        // Kicker
                        if (o.show_kicker) {
                            const kicker = clone.querySelector('[slot="kicker"]');
                            if (asset.kicker) {
                                kicker.innerHTML = asset.kicker;
                            }
                        }
                        
                        // Hammer
                        if (o.show_hammer) {
                            const hammer = clone.querySelector('[slot="hammer"]');
                            if (asset.hammer) {
                                hammer.innerHTML = asset.hammer;
                            }
                        }
                        
                        // Summary/lead
                        if (o.show_lead) {
                            const lead = clone.querySelector('[slot="lead"]');
                            const readmore = clone.querySelector('[slot="readmore"]');
                            if (asset.summary) {
                                lead.innerHTML = asset.summary;
                                
                                // Readmore 
                                if (o.show_readmore) {
                                    readmore.href = asset.url;
                                }
                            } else {
                                lead.remove();
                                readmore?.remove();
                            }
                        }
                        
                        // Date
                        if (o.show_date) {
                            const date = clone.querySelector('blox-format-date');
                            const seconds = Math.floor(Date.now() / 1000);
                            let time = "";
                            // Updated vs start
                            if (
                                seconds - (30 * 86400) < asset.starttime.utc
                                && seconds - (7 * 86400) < asset.last_updated
                                && seconds > asset.last_updated
                            ) {
                                time = asset.updated;
                            } else {
                                time = asset.starttime;
                            }
                            if (time) date.setAttribute("date", time.iso8601);
                        }
                        
                        // Author
                        if (o.show_author) {
                            if (asset.authors.length > 0) {
                                const author = asset.authors[0];
                                const name = author.full_name ?? author.screen_name;
                                clone.querySelector('[slot="author"]').innerHTML = name;
                                clone.querySelectorAll('[slot="author"]').forEach((link) => {
                                    link.href = author.profile;
                                });
                            } else {
                                clone.querySelector('[slot="author"]').remove();
                            }
                        }
                        
                        // Byline
                        if (o.show_byline) {
                            if (asset.byline) {
                                clone.querySelector('[slot="byline"]').innerHTML = asset.byline;
                            } else {
                                clone.querySelector('[slot="byline"]').remove();
                            }
                        }
                        
                        // Time to consume
                        if (o.show_time_to_read) {
                            const consume = clone.querySelector('[slot="time-to-read"]');
                            if (consume && asset.time_to_consume) {
                                consume.textContent = asset.time_to_consume;
                            }
                        }
                        
                        // Section
                        if (o.show_sections) {
                            const section = clone.querySelector('[slot="sections"]');
                            if (asset.sections && asset.sections[0]) {
                                if (!o.section_max) o.section_max = 1;
                                for (let i = 0; i < asset.sections.length; i++) {
                                    if (i >= o.section_max) break;
                                    
                                    if (asset.sections[i].path) {
                                        // Create linked tag
                                        const tag = section.cloneNode();
                                        tag.href = asset.sections[i].path;
                                        tag.textContent = asset.sections[i].tag;
                                        card.appendChild(tag);
                                    } else {
                                        // Create unlinked tag
                                        const tag = document.createElement("span");
                                        tag.slot = 'sections';
                                        tag.textContent = asset.sections[i].tag;
                                        card.appendChild(tag);
                                    }
                                }
                            }
                            section.remove();
                        }
                        
                        // Flags
                        if (o.show_flags) {
                            const flags = clone.querySelector('[slot="flags"]');
                            if (asset.flags) {
                                asset.flags.forEach((flagText) => {
                                    const flag = flags.cloneNode();
                                    flag.innerHTML = flagText.replace(/_/g, " ").replace("editors", "editor's");
                                    flag.classList.add("blox-flag-" + flagText);
                                    card.appendChild(flag);
                                });
                            }
                            flags.remove();
                        }
                        
                        // Image
                        if (o.show_image) {
                            const preview = clone.querySelector('[slot="image"]');
                            const source = clone.querySelector('[slot="image"] picture source');
                            const img = clone.querySelector('[slot="image"] picture img');
                            if (asset.preview.srcset) {
                                const srcsetArray = asset.preview.srcset.split(",").map((size) => `${asset.preview.url} ${size}w`);
                                preview.href = asset.url;
                                preview.ariaLabel = 'View ' + asset.title;
                                source.srcset = srcsetArray.join(",");
                                img.src = asset.preview.url;
                                img.srcset = srcsetArray.join(",");
                                img.width = asset.preview.width;
                                img.height = asset.preview.height;
                            } else if (asset.preview.url) {
                                preview.href = asset.url;
                                preview.ariaLabel = 'View ' + asset.title;
                                img.src = asset.preview.url;
                                img.alt = asset.title;
                                img.width = asset.preview.width;
                                img.height = asset.preview.height;
                            } else {
                                preview.remove();
                            }
                        }
                        
                        // Comments
                        if (o.show_comments) {
                            const comments = clone.querySelector("[slot='comments']");
                            comments.href = comments.href.replace('{{url}}', asset.url);
                        }
                        
                        // Push completed card
                        cards.push(document.importNode(clone, true));
                    });
                };
                
                const hideTrigger = () => {
                    target.hidden = true;
                };
            })
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener('DOMContentLoaded', () => {
            discovery.init();
        })
    } else {
        discovery.init();
    }
})();